import { useQuery } from '@tanstack/react-query';
import { getMentors } from '../../../services';
import { IMentor, IMentorDetails } from '../../../types';

const useGetMentors = () => {
  const { data, isError, isLoading, isSuccess } = useQuery<{
    mentors: IMentor[];
    mentorsDetails: IMentorDetails[];
  }>(['mentors'], getMentors);
  const { mentors, mentorsDetails } = data ?? {
    mentors: [],
    mentorsDetails: [],
  };

  const mentorWithDetails = mentors?.reduce(
    (mentorList: IMentor[], mentor: any) => [
      ...mentorList,
      {
        ...mentor,
        details: mentorsDetails?.find(
          (item: IMentorDetails) => item.email === mentor.email,
        ),
      },
    ],
    [],
  );

  return {
    data: mentorWithDetails,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useGetMentors;
